module.exports = __webpack_public_path__ + "5b7887069546527a43505c8c260371e1.png";